import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import styles from './CreateTicketModal.module.scss';
import { stripTags } from '../../../../../Utils/sanitize';

const CreateTicketModal = ({ isOpen, onClose, onSave, categories }) => {
    const location = useLocation();
    const [Type, setType] = useState('');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const titleLimit = 50;
    const descriptionLimit = 1000;

    useEffect(() => {
        if (location.state?.category) {
            setType(location.state.category);
        }
    }, [location.state]);

    if (!isOpen) {
        return null;
    }

    const isSaveDisabled = !Type || !title || !description || title.length > titleLimit || description.length > descriptionLimit;

    const handleSave = () => {
        if (isSaveDisabled) {
            alert('Please fill in all required fields and respect the character limits.');
            return;
        }
        onSave({ Type, Title: stripTags(title).trim(), Description: stripTags(description).trim() });
        // Reset form and close modal
        setType('');
        setTitle('');
        setDescription('');
        onClose();
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <div className={styles.modalHeader}>
                    <h3>Create Support Ticket</h3>
                    <button onClick={onClose} className={styles.closeButton}>
                        <i className="material-icons">close</i>
                    </button>
                </div>
                <div className={styles.modalBody}>
                    <div className={styles.formGroup}>
                        <label>Category <span>*</span></label>
                        <select value={Type} onChange={(e) => setType(e.target.value)}>
                            <option value="">Select Category...</option>
                            {categories.map(cat => (
                                <option key={cat.value} value={cat.value}>{cat.text}</option>
                            ))}
                        </select>
                    </div>
                    <div className={styles.formGroup}>
                        <label>Title <span>*</span></label>
                        <input type="text" value={title} onChange={(e) => setTitle(stripTags(e.target.value))} maxLength={titleLimit} />
                        <small>{title.length}/{titleLimit}</small>
                    </div>
                    <div className={styles.formGroup}>
                        <label>Description <span>*</span></label>
                        <textarea value={description} onChange={(e) => setDescription(stripTags(e.target.value))} maxLength={descriptionLimit}></textarea>
                        <small>{description.length}/{descriptionLimit}</small>
                    </div>
                </div>
                <div className={styles.modalFooter}>
                    <button onClick={onClose} className={styles.closeBtn}>Close</button>
                    <button onClick={handleSave} className={styles.saveBtn} disabled={isSaveDisabled}>Save Ticket</button>
                </div>
            </div>
        </div>
    );
};

export default CreateTicketModal;